export default {
  namespaced: true,
  state: {
    // 树信息搜索框关键字
    searchValue: "",
    microList: JSON.parse(sessionStorage.getItem("microList")) || null,
    macroList: JSON.parse(sessionStorage.getItem("macroList")) || null,
  },
  mutations: {
    changeSearchValue(state, searchValue) {
      state.searchValue = searchValue;
    },
    setMicroList(state, microList) {
      state.microList = microList;
    },
    setMacroList(state, macroList) {
      state.macroList = macroList;
    },
  },
  actions: {
    changeSearchValue({ commit }, searchValue) {
      commit("changeSearchValue", searchValue);
    },
    setMicroList({ commit }, microList) {
      commit("setMicroList", microList);
    },
    setMacroList({ commit }, macroList) {
      commit("setMacroList", macroList);
    },
  },
};
